/**
 * @desc 新增订单
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(body: defs.omsFlow.SystemOrderSaveParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/omsflow/addOrder`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
